import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { useCallback } from 'react';

import type { PrivateKeyRecoveryInput } from '#src/__generated__/globalTypes.ts';
import { walletRecovery } from '#src/contexts/currentUser/queries.ts';
import { useMutation } from '#src/hooks/graphql/useMutation.ts';

import type {
  AddWalletRecoveryEmailMutation,
  AddWalletRecoveryEmailMutationVariables,
} from './__generated__/useAddWalletRecoveryEmail.graphql.ts';

const ADD_WALLET_RECOVERY_EMAIL = gql`
  mutation AddWalletRecoveryEmailMutation($input: addWalletRecoveryInput!) {
    addWalletRecovery(input: $input) {
      currentUser {
        slug
        ...CurrentUserProvider_walletRecovery
      }
      errors {
        path
        message
        code
      }
    }
  }
  ${walletRecovery}
` as TypedDocumentNode<
  AddWalletRecoveryEmailMutation,
  AddWalletRecoveryEmailMutationVariables
>;

export const useAddWalletRecoveryEmail = () => {
  const [mutate, { loading }] = useMutation(ADD_WALLET_RECOVERY_EMAIL, {
    showErrorsInForm: true,
  });

  const addWalletRecoveryEmail = useCallback(
    async ({
      privateKeyRecovery,
      otpAttempt,
    }: {
      privateKeyRecovery: PrivateKeyRecoveryInput;
      otpAttempt?: string;
    }) => {
      const input = {
        privateKeyRecovery,
        ...(otpAttempt && { otpAttempt }),
      };
      const result = await mutate({
        variables: {
          input,
        },
      });
      return result;
    },
    [mutate]
  );

  return {
    addWalletRecoveryEmail,
    loading,
  };
};
